<template>
   <el-container class="layout-container-global">
      <el-container class="main-container">
         <el-header height=160px>
            <div class="header-box">
               <el-row style="width: 100%; align-items: center; justify-content: space-between;">
                  <el-col :xs="0" :sm="0" :md="0" :lg="2" :xl="2">
                  </el-col>
                  <el-col :span="3" :xs="10" :sm="10" :md="8" :lg="4" :xl="4">
                     <div class="top-logo">
                     <el-image :src="require('@/assets/global-ptt-logo.png')" />
                     </div>
                  </el-col>
                  <el-col :xs="6" :sm="6" :md="8" :lg="0" :xl="0" class="top-text">HOME</el-col>
                  <el-col :span="1" :xs="8" :sm="8" :md="8" :lg="0" :xl="0" class="top-aside-menu">
                     <el-image :src="require('@/assets/Vector.png')" style="height: 30px;"
                     @click="showMenu"/>
                  </el-col>
                  <el-col :span="10" :xs="0" :sm="0" :md="0" :lg="10" :xl="10">
                     <div class="menu-top">
                        <div v-for="menu in menuList"  class="link-box"
                        @click="goTomenu(menu.name)"><el-link class="link-item" v-if="menu.isShow">{{menu.name}} </el-link></div>
                     </div>
                  </el-col>
                  <el-col :span="5" :xs="0" :sm="0" :md="0" :lg="5" :xl="5">
                     <div class="top-button-group">
                        <div class="botton-box">
                        <el-button
                        @click="contactUs"
                        style="height: 100%; width: 80%">
                           Contact us<el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                     </div>
                     <div class="botton-box botton-box2">
                        <el-button text link
                        @click="goTomenu('Platform')"
                        style="color: #fff; font-weight: bold; border: 1px solid #FFFFFF;
                        height: 100%; width: 80%;">
                           Sign in <el-icon class="el-icon--right"><Right /></el-icon>
                        </el-button>
                        </div>
                     </div>
                  </el-col>
                  <el-col :xs="0" :sm="0" :md="0" :lg="2" :xl="2">
                  </el-col>
               </el-row>
            </div>
         </el-header>
         <el-main>
            <div style="margin: 0 0px;">
               <router-view></router-view>
            </div>
            <el-drawer v-model="menuVisable" title="aside menu"
            :with-header="false"
               size="50%"
               :show-close="false" style="margin-top: 83px;" >
               <div v-for="menu in menuList" >
                  <div  class="menu-item-aside"
                  @click="goTomenu(menu.index)"  v-if="menu.showOnMobile"> {{ menu.name }}</div>
                  <el-divider style="margin: 5px 0px;" v-if="menu.showOnMobile"/>
               </div>
            </el-drawer>
         </el-main>
         <el-footer height="633px">
            <div class="main-footer">
               <div class="footer-box">
                  <div class="production-box">
                     <div class="foot-list-moudule">
                        <div v-for="x in mouduleList"  class="list-desc">
                           <div class="f-title">{{x.name}}</div>
                           <div class="f-list-item" v-for="y in x.children">
                              <el-link v-if="y.type=='link'" style="color: #fff"
                              target="_self"
                              :href="y.link">{{ y.label }}</el-link>
                              <el-link v-if="y.type=='button'" style="color: #fff"
                              target="_blank"
                              @click="y.click">{{ y.label }}</el-link>
                           </div>
                        </div>
                     </div>
                     <div class="f-img">
                        <el-image :src="require('@/assets/global-ptt-logo.png')" style="height: 100px;"/>
                     </div>
                  </div>
                  <el-divider style="opacity: 0.5; margin: 5px 0px;"/>
                  <div class="footer-bar">
                     <el-row style="align-items: center;">
                        <el-col :span="8"></el-col>
                        <el-col :span="8" class="copyright">©2014-2024 global-ptt LLC</el-col>
                        <el-col :span="4"></el-col>
                        <el-col :span="4"><div class="foot-logos">
                           <div v-for="img in footLogos" class="foot-logo-img" @click="clickLink(img.link)">
                           <el-link>
                           <el-image :src="img.image" style="height: 41px; width: 41px;"/>
                           </el-link>
                        </div>
                        </div></el-col>
                     </el-row>
                  </div>
               </div>
            </div>
            <div class="mobile-footer" >
               <div v-for="img in footLogos" class="foot-logo-img" @click="clickLink(img.link)">
               <el-image :src="img.image" style="height: 41px; width: 41px;"/>
               </div>
            </div>
         </el-footer>

      </el-container>
   </el-container>
   <ContactUsDrawer :show='showContact' @close='closeContact' />
   <MobileContactDrawer :visible='contactVisable' @update:visible="closeMobileContact" />


</template>
<script setup>
import { ref, computed } from 'vue';
import { Right } from '@element-plus/icons-vue'
import { useStore } from 'vuex';
import { goTomenu, getPageDesc } from '@/utils/storeUtils'
import { clickLink } from '@/utils/common'
import { ElMessage, ElMessageBox } from 'element-plus'
import ContactUsDrawer from '@/components/ContactUsDrawer.vue'
import MobileContactDrawer from '@/components/MobileContactDrawer.vue'
import { contactVisable } from '@/utils/globalFunc'
import { clickApi, clickContact } from '@/utils/globalFunc'

// console.log('process.env.baseurl', process.env.BASE_URL)

const store = useStore()
const menuList = computed(() => {
   let menus = store.getters.getMenus
   menus =  menus.filter(menu => menu.isShow !== false)

   return menus
})
// const menuList = ref(store.getters.getMenus
// )

// const showContact = ref(false)

const footLogos = ref([
   {image: require('@/assets/foot-skype.png'),link: 'https://join.skype.com/invite/wcz6heX5LppG?source=qr-ios'},
   {image: require('@/assets/foot-whats.png'), link: 'https://api.whatsapp.com/message/FCEMIVBOEPHRO1?autoload=1&app_absent=0'},
   {image: require('@/assets/foot-facebook.png'), link:'https://www.facebook.com/globalptt.official/' },
   {image: require('@/assets/foot-ins.png'), link: 'https://www.linkedin.com/in/global-ptt' }
])

const menuVisable = ref(false)

const showMenu = ()=> {
   menuVisable.value=true
}

const clickWait = () => {
   ElMessageBox.alert(
      'Features are waiting to be developed',
      'A new Feature',
         {
        confirmButtonText: 'OK',
         }
   )
}

const contact = ref(
   store.state.home.contact
)
console.log('contact', contact)

const contactUs = () => {
   console.log('contact us')
   showContactDrawer.value = true;
}
const showContactDrawer = ref(false)

const showContact = computed({
  get() {
    return showContactDrawer.value
  },
  set(val) {
    return val
  }
})

const closeContact = () =>{
   showContactDrawer.value = false;
}

const closeMobileContact = () => {
   contactVisable.value = false
}
const mouduleList = ref([
   { name: 'Company', children: [
      {label: 'About us', link: 'http://product.global-ptt.com', type: 'link', },
      {label: 'Contact us', link: '' , type: 'button', click: contactUs},
      {label:'Catalog', link: '/global-ptt_product_catalog.pdf',type: 'link'}] },
   { name: 'Product', children: [
      {label:'Radio', link: 'https://txq-radio.com/' ,type: 'link'},
      {label: 'Sim', link: 'https://iot.global-ptt.com/#/searchindex' ,type: 'link'},
      // { label: 'License', link: ' https://txq-radio.com/DownLoad/110388.html?a=download', type: 'link' }
      ] },
   {name: 'Solution', children: [
      {label: 'Module', link: 'https://txq-radio.com/Product/597570.html',type: 'link'},
      {label: 'Api', link: '',type: 'button', click: () => {
          clickApi('/apidoc.zip','The file will automatically download in 5 seconds.Contact us to obtain the file decompression password.');
        }},
      {label: 'Deploy', link: 'https://txq-radio.com/Content/2439074.html',type: 'link'},
      ]}
])

</script>

<style scoped>
.layout-container-global {
  font-size: 2rem;
  justify-content: center;
}
.main-container {
   width: 100vw;
   min-width: 1366px;
}
.el-header {
  --el-header-padding: 0px 0px;
}
.el-footer {
  --el-footer-padding: 0px 0px;
  height: 60px;
}
.top-logo {
   width: 209px;
   height: 100px;
   position: relative;
   left: 60px;
}
.layout-container-global .el-header {
   justify-content:flex-end;
}
.header-box {
   height: 160px;
   box-shadow: 0px 3px 10px #53829833;
   padding: 0 0 0 0;
   display: flex;
   background: linear-gradient( 161deg, #014BC4 0%, #00A0FD 100%);
}
.row-bg{
   padding-top: 20px;
}
.header-box > .el-col {
   align-self: center;
}
.el-main {
   --el-main-padding: 0px;
}
.el-main {
   --el-main-padding: 0px;
}
.el-menu--horizontal.el-menu  {
   border-bottom: none;
   text-decoration: none;
}
.menu-top {
   font-size: 1rem;
   font-family: PingFang SC;
   font-weight: bold;
   color: #fff;
   letter-spacing: 1px;
   font-style: normal;
   position: relative;
   left: 17px;
   display: flex;
}
.link-box {
   margin: 0 3.9%;
}
.top-button-group {
   display: flex;
   position: relative;
   left: 30px;
}
.link-item {
   color: #fff;
   font-size: 1rem;
}
.botton-box {
   display: flex;
   height: 56px;
   align-items: center;
   width: 196px;
}
.botton-box2 {
   width: 156px;
}
.el-menu--horizontal>.el-menu-item {
    padding: 0px 10px 0px 10px;
}
.flex-grow {
  flex-grow: 1;
}
.title-box{
   font-size: 0.3rem;
}

.main-footer{
   height: 633px;
   background: linear-gradient( 137deg, #023FBC 0%, #009EFB 100%);
   display: flex;
   justify-content: center;
}
.footer-box {
   width: 80%;
}
.production-box {
   height: 465px;
   justify-content: space-between;
   display: flex;
}
.footer-bar {
   height: 82px;
   margin: 37px 0px;
}
.foot-list-moudule {
   display: flex;
   flex-direction: row;
}
.f-title {
   color: #fff;
   font-family: PingFang SC;
   font-weight: 8px;
   margin-bottom: 50px;
   font-size: 1.2rem;
}
.f-list-item {
   font-size: 1rem;
   color: #fff;
   margin-bottom: 28px;
}
.list-desc{
   margin: 120px 30% 30px 20px;
   display: flex;
   flex-direction: column;
   align-items: start;
}
.f-img {
   margin: 120px 20px 20px 40px;
}
.copyright {
   font-size: 1rem;
   color: #fff;
   align-items: center;
   font-weight: 800;
}
.foot-logos {
   display: flex;
   margin: 0px 50px;
   justify-content: center;
}
.foot-logo-img {
   margin: 0px 14px;
}
.foot-logo-in {
   color: #fff;
   font-weight: bold;
   position: absolute;
   bottom: 5px;
}
.top-text {
   margin-top: 20px;
   font-size: 1.4rem;
   color: #fff;
   font-weight: bold
}
.top-aside-menu {
   display: flex;
   justify-content: flex-end;
   padding: 0px 10px;
   margin-top: 20px;
}
.mobile-footer{
   display: none;
}
/* 在小屏幕上修改样式 */
@media screen and (max-width: 550px) {
   .el-header {
      height: 80px;
   }
   .header-box{
      height:80px;
   }
   .top-logo{
      margin-top: 20px;
      width: 71px;
      height: 36px;
      left: 20px;
      border-bottom: 6px;
   }
  .main-container {
    min-width: 0px;
  }
  .main-footer{
   display: none;
  }
  .mobile-footer{
   display: flex;
   background: linear-gradient( 177deg, #0081E8 0%, #019EFB 100%);
   height: 85px;
   width: 100%;
   justify-content: center;
   align-items: center;
   }
   .menu-item-aside {
      margin: 16px 20px 16px 10px;
      justify-content: flex-end;
      display: flex;
      font-size: 1rem;
   }
}
</style>
